import queryString from "query-string";
import { $CombinedState } from "redux";
import services from "../../../../services";
import $ from 'jquery';
import ClassGrid2 from "./ClassGrid2";
import {itemChange} from "./ClassGrid2"

let data = [];
var data2 = [];
const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.Columns = [];
    item.IDAutoDetalhe = 0;
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;
};

export const dataGet2 = async () => {
    return data;
};
export const getItems2 = async () => {
    var ArrayDetalhesGrid = []
    
    if(window.location.search != ""){
            var queryParams = queryString.parse(window.location.search)
            var  token = queryParams.idAuto
            var  dataToken = {"idAuto": token}
            var Detalhes = await services.apiCall.requestApi(
                "/Fiscalizacao/GetAutoDetalhe",
                dataToken,
                "get"
            ); 
       
            for (let index = 0; index < Detalhes.autoGrid.length ; index++) {
                var etiqueta_ivdp = []
                var etiqueta_ae = []
                var etiquetasSegurancaAE = []
                var etiquetasSegurancaIVDP = []
                var SelosSeguranca = []
                var selos = []
                var capacidadeAE = Detalhes.autoGrid[index].capacidadeAE;
                var capacidadeCalculada = Detalhes.autoGrid[index].capacidadeCalculada;
                var capacidadeIVDP = Detalhes.autoGrid[index].capacidadeIVDP;
                var contaCorrenteDesc = Detalhes.autoGrid[index].contaCorrenteDesc;
                var falta = Detalhes.autoGrid[index].falta;
                var idCapacidadeAE = Detalhes.autoGrid[index].idCapacidadeAE;
                var idCapacidadeIVDP = Detalhes.autoGrid[index].idCapacidadeIVDP;
                var idContaCorrente = Detalhes.autoGrid[index].idContaCorrente;
                var idVasilha = Detalhes.autoGrid[index].idVasilha;
                var numeroGarrafasAE = Detalhes.autoGrid[index].numeroGarrafasAE;
                var numeroGarrafasIVDP = Detalhes.autoGrid[index].numeroGarrafasIVDP;
                var numeroRegisto = Detalhes.autoGrid[index].numeroRegisto;
                var numeroVasilha = Detalhes.autoGrid[index].numeroVasilha;
                var quantidadeAferida = Detalhes.autoGrid[index].quantidadeAferida;
                var registoDeposito = Detalhes.autoGrid[index].registoDeposito;
                var tipoMedicao = Detalhes.autoGrid[index].tipoMedicao;
                var tipoVasilha =  Detalhes.autoGrid[index].tipoVasilha;
                var linha = Detalhes.autoGrid[index].linha;
                var documentoEntrada = Detalhes.autoGrid[index].documentoEntrada;
                var documentoSaida = Detalhes.autoGrid[index].documentoSaida;
                var idRegistoProduto = Detalhes.autoGrid[index].idRegistoProduto;
                var idRotulo = Detalhes.autoGrid[index].idRotulo;
                var correlativa =  Detalhes.autoGrid[index].correlativa;
                var numeroLote = Detalhes.autoGrid[index].numeroLote;
                var numeroGarrafasDevolvidas = Detalhes.autoGrid[index].numeroGarrafasDevolvidas;
                var numeroLote = Detalhes.autoGrid[index].numeroLote;
                var quantidadeFinal = Detalhes.autoGrid[index].quantidadeFinal;
                var numeroGarrafasAmostra = Detalhes.autoGrid[index].numeroGarrafasAmostra;
                var motivoDispensa = Detalhes.autoGrid[index].motivoDispensa;
                var capacidadeCorrelativa = Detalhes.autoGrid[index].capacidadeCorrelativa;
                var RegistoProduto= {text: Detalhes.autoGrid[index].contaCorrenteDesc , value: Detalhes.autoGrid[index].idContaCorrente};
                var Correlativa= Detalhes.autoGrid[index].correlativa;
                var NLote= Detalhes.autoGrid[index].numeroLote ;
                var NGarrafas= String(Detalhes.autoGrid[index].numeroGarrafasAE);
                var ProductID= Detalhes.autoGrid[index].linha;
                var quantidadeAferida = Detalhes.autoGrid[index].quantidadeAferida;
                var quantidadeAferidaIE = Detalhes.autoGrid[index].quantidadeAferidaIE;
                var quantidadeAferidaIG = Detalhes.autoGrid[index].quantidadeAferidaIG;
                var quantidadeAferidaPA = Detalhes.autoGrid[index].quantidadeAferidaPA;
                var quantidadeAferidaVendas = Detalhes.autoGrid[index].quantidadeAferidaVendas;
                var quantidadeFinal = Detalhes.autoGrid[index].quantidadeFinal;
                var quantidadeRotulo = Detalhes.autoGrid[index].quantidadeRotulo;
                var quantidadeTotalIE = Detalhes.autoGrid[index].quantidadeTotalIE;
                var quantidadeTotalIG = Detalhes.autoGrid[index].quantidadeTotalIG;
                var quantidadeTotalPA = Detalhes.autoGrid[index].quantidadeTotalPA;
                var tipoRotulo = Detalhes.autoGrid[index].tipoRotulo;
                var TotalQBD= Detalhes.autoGrid[index].quantidadeFinal;
                var TotalQA = Detalhes.autoGrid[index].quantidadeAferidaTotal;
                var TotalQT = Detalhes.autoGrid[index].quantidadeTotal;
                var linha = Detalhes.autoGrid[index].linha;

                if(correlativa != null){
                    var valor = correlativa.split("-")[1]
                }else{
                    var valor = ""
                }
                etiquetasSegurancaAE = Detalhes.autoGrid[index].etiquetasSegurancaAE;
                etiquetasSegurancaIVDP = Detalhes.autoGrid[index].etiquetasSegurancaIVDP;
                selos = Detalhes.autoGrid[index].selosSeguranca;
                
                if(etiqueta_ae.length == 0){
                    etiquetasSegurancaAE.map((etiquetasSegurancaAE) => (
                        etiqueta_ae.push(etiquetasSegurancaAE.idEtiqueta)
                    
                    ));
                }
                if(etiqueta_ivdp.length == 0){
                    etiquetasSegurancaIVDP.map((etiquetasSegurancaIVDP) => (
                        etiqueta_ivdp.push(etiquetasSegurancaIVDP.idEtiqueta )
                    
                    ));
                }

                if(selos != undefined){
                    if(SelosSeguranca.length == 0){
                        selos.map((selos) => (
                            SelosSeguranca.push(selos.idSelo )
                        
                        ));
                    }
                }

                if($("#tipo_auto :selected").val() == "4"){
                   
                    const datax = {"numeroRegisto" : numeroRegisto , "idEntidade": parseInt($("#instal_vinica_auto :selected").val().split("!")[1])}
                    var ContaCorrenteAgrupada = await services.apiCall.requestApi(
                        "/Fiscalizacao/GetContaCorrenteAgrupada",
                        datax,
                        "get"
                    );

                    var prodAcabado = 0;
                    var indGranel = 0;
                    var indEngarrafado = 0;
    
                    for (let index = 0; index < ContaCorrenteAgrupada.length; index++) {
                        if(ContaCorrenteAgrupada[index].produtoAcabado != null && ContaCorrenteAgrupada[index].produtoAcabado != ""){
                            prodAcabado = parseFloat(ContaCorrenteAgrupada[index].produtoAcabado)
                        }
                        if(ContaCorrenteAgrupada[index].indisponivelGranel != null && ContaCorrenteAgrupada[index].indisponivelGranel != ""){
                            indGranel = parseFloat(ContaCorrenteAgrupada[index].indisponivelGranel)
                        }
                        if(ContaCorrenteAgrupada[index].indisponivelEngarrafado != null && ContaCorrenteAgrupada[index].indisponivelEngarrafado != ""){
                            indEngarrafado = parseFloat(ContaCorrenteAgrupada[index].indisponivelEngarrafado)
                        }
                    }


                    var IndispGranelQBD = indGranel;
                    var IndispEngaQBD =indEngarrafado;
                    var ProdutoAcabadoQBD = prodAcabado;
                    var TotalQBD = indGranel + indEngarrafado + prodAcabado;
                    
                    data.push({
                        Registo_DO : {text: numeroRegisto, value: idRegistoProduto},
                        IndispGranelQA: quantidadeAferidaIG,
                        IndispEngaQA: quantidadeAferidaIE,
                        ProdutoAcabadoQA: quantidadeAferidaPA,
                        VendasQA: quantidadeAferidaVendas,
                        IndispGranelQT: quantidadeTotalIG,
                        IndispEngaQT: quantidadeTotalIE,
                        ProdutoAcabadoQT: quantidadeTotalPA,
                        IndispGranelQBD: IndispGranelQBD,
                        IndispEngaQBD: IndispEngaQBD,
                        ProdutoAcabadoQBD: ProdutoAcabadoQBD,
                        TotalQBD: TotalQBD,
                        ProductID : linha,
                        IDAutoDetalhe: Detalhes.autoGrid[index].idAutoDetalhe,
                        TotalQA : TotalQA,
                        TotalQT : TotalQT,
                        Discontinued: false,
                        inEdit: false
                 })
                    
                }  
            }
            
            return data; 
    }else{
        return data
    }
}

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};


export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
// export const datagrid2 = item =>{
//     data = item
//     getItems2()
// }